import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import '../../ui/popups/Popup/BasePopup/index.js';
import '../../ui/popups/Popup/Thumb/index.js';
import { ThumbV2 } from '../../ui/popups/Popup/ThumbV2/index.js';
import '../../ui/popups/Popup/InfoTooltip/index.js';
import { Select } from '../Select/index.js';
import styles from './index.module.scss.js';

const FormSelect = ({
  name,
  label,
  value = [],
  placeholder,
  options,
  required,
  disabled,
  errors,
  errorMsgAbsolute,
  onBlur = () => {
  },
  onChange = () => {
  },
  onFocus = () => {
  },
  onKeyPress = () => {
  },
  onKeyUp = () => {
  },
  size,
  className,
  style,
  ...props
}) => {
  const [innerValue, setInnerValue] = useState(value);
  useEffect(() => {
    setInnerValue(value);
  }, [value]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(styles.box, className, {
        [styles.error]: !!errors,
        [styles[size || ""]]: !!size
      }),
      style
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.box__inner }, label && /* @__PURE__ */ React.createElement(
      "label",
      {
        className: cx(styles.label, {
          [styles.required]: required
        }),
        htmlFor: name
      },
      label
    ), /* @__PURE__ */ React.createElement("div", { className: styles.input__wrapper, id: name }, /* @__PURE__ */ React.createElement(
      Select,
      {
        onSelect: onChange,
        options,
        selectedIds: innerValue ? [innerValue] : [],
        renderThumb: (thumbProps) => /* @__PURE__ */ React.createElement(
          ThumbV2,
          {
            ...thumbProps,
            onKeyUp,
            onBlur,
            onFocus,
            onKeyPress,
            disabled,
            thumbLabel: innerValue.length ? "" : placeholder,
            text: innerValue.length ? thumbProps.text : "",
            formType: true
          }
        ),
        version: "v2",
        theme: "blue"
      }
    ))),
    errors && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.error, {
          [styles.absolute]: errorMsgAbsolute
        })
      },
      errors.message
    )
  );
};
FormSelect.displayName = "FormSelect";

export { FormSelect };
//# sourceMappingURL=index.js.map
